export default class TrackItemMenuOpened {
  constructor(context) {
    this.context = context;
  }

  run({ itemId, itemType, location }) {
    this.context.analytics.track('Conversation Item Menu Opened', {
      itemId,
      itemType,
      location,
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/conversation_item/task/track_item_menu_opened.js